import UserIndex from '../views/index/user/index.vue';

export const user = {
  path: '/user',
  name: 'user',
  component: UserIndex,
  children: [
    {
      path: 'profile',
      name: 'menu.user.profile',
      meta: {
        isParent: true,
        icon: 'fas fa-address-card',
      },
      component: () => import('../views/index/user/profile/Profile.vue'),
    },
    {
      path: 'identification',
      name: 'menu.user.identification',
      meta: {
        isParent: true,
        icon: 'fas fa-id-card',
      },
      component: () => import('../views/index/user/identification/Identification.vue'),
    },
    {
      path: 'identification/new',
      name: 'menu.user.identification.new',
      meta: {
        parentName: 'menu.user.identification',
        parentIcon: 'fas fa-id-card',
      },
      component: () => import('../views/index/user/identification/IdentificationSteps.vue'),
      children: [
        {
          path: 'step1',
          name: 'menu.user.identification.new.step1',
          meta: {
            stepPercent: 10,
            prev: '',
            next: 'step2',
          },
          component: () => import('../views/index/user/identification/Step1/Step1.vue'),
        },
      ],
    },
    {
      path: 'identification/:id',
      name: 'menu.user.identification.edit',
      meta: {
        parentName: 'menu.user.identification',
        parentIcon: 'fas fa-id-card',
      },
      component: () => import('../views/index/user/identification/IdentificationSteps.vue'),
      children: [
        {
          path: 'step1',
          name: 'menu.user.identification.edit.step1',
          meta: {
            stepPercent: 10,
            prev: '',
            next: 'step2',
          },
          component: () => import('../views/index/user/identification/Step1/Step1.vue'),
        },
        {
          path: 'step2',
          name: 'menu.user.identification.edit.step2',
          meta: {
            stepPercent: 20,
            prev: 'step1',
            next: 'step3',
          },
          component: () => import('../views/index/user/identification/Step2/Step2.vue'),
        },
        {
          path: 'step3',
          name: 'menu.user.identification.edit.step3',
          meta: {
            stepPercent: 30,
            prev: 'step2',
            next: 'step4',
          },
          component: () => import('../views/index/user/identification/Step3/Step3.vue'),
        },
        {
          path: 'step4',
          name: 'menu.user.identification.edit.step4',
          meta: {
            stepPercent: 40,
            prev: 'step3',
            next: 'step5',
          },
          component: () => import('../views/index/user/identification/Step4/Step4.vue'),
        },
        {
          path: 'step5',
          name: 'menu.user.identification.edit.step5',
          meta: {
            stepPercent: 50,
            prev: 'step4',
            next: 'step6',
          },
          component: () => import('../views/index/user/identification/Step5/Step5.vue'),
        },
        {
          path: 'step6',
          name: 'menu.user.identification.edit.step6',
          meta: {
            stepPercent: 60,
            prev: 'step5',
            next: 'step7',
          },
          component: () => import('../views/index/user/identification/Step6/Step6.vue'),
        },
        {
          path: 'step7',
          name: 'menu.user.identification.edit.step7',
          meta: {
            stepPercent: 70,
            prev: 'step6',
            next: 'step8',
          },
          component: () => import('../views/index/user/identification/Step7/Step7.vue'),
        },
        {
          path: 'step8',
          name: 'menu.user.identification.edit.step8',
          meta: {
            stepPercent: 80,
            prev: 'step7',
            next: 'step9',
          },
          component: () => import('../views/index/user/identification/Step8/Step8.vue'),
        },
        {
          path: 'step9',
          name: 'menu.user.identification.edit.step9',
          meta: {
            stepPercent: 90,
            prev: 'step8',
            next: 'step10',
          },
          component: () => import('../views/index/user/identification/Step9/Step9.vue'),
        },
        {
          path: 'step10',
          name: 'menu.user.identification.edit.step10',
          meta: {
            stepPercent: 99,
            prev: 'step9',
            next: '',
          },
          component: () => import('../views/index/user/identification/Step10/Step10.vue'),
        },
        {
          path: 'step10/:clause',
          name: 'menu.user.identification.edit.step10.clause',
          meta: {
            stepPercent: 99,
            prev: 'step10',
          },
          component: () => import('../views/index/user/identification/Step10/PdfViewer.vue'),
        },
      ],
    },
    {
      path: 'deposit',
      name: 'menu.user.deposit.new',
      meta: {
        parentName: 'menu.user.deposit',
        parentIcon: 'fas fa-money-bill-alt',
      },
      // component: () => import('../views/index/user/deposit/Deposit.vue'),
      component: () => import('../views/index/user/deposit/DepositNew.vue'),
    },
    {
      path: 'deposit/history',
      name: 'menu.user.deposit',
      meta: {
        isParent: true,
        icon: 'fas fa-money-bill-alt',
      },
      component: () => import('../views/index/user/deposit/DepositHistory.vue'),
    },
    {
      path: 'deposit/:id',
      name: 'menu.user.deposit.edit',
      meta: {
        parentName: 'menu.user.deposit',
        parentIcon: 'fas fa-money-bill-alt',
      },
      component: () => import('../views/index/user/deposit/DepositEdit.vue'),
    },
    // {
    //   path: 'deposit/depositUrl',
    //   name: 'menu.user.deposit.url',
    //   meta: {
    //     parentName: 'menu.user.deposit',
    //     parentIcon: 'fas fa-money-bill-alt',
    //   },
    //   component: () => import('../views/index/user/deposit/DepositUrl.vue'),
    // },
    // {
    //   path: 'deposit/competition',
    //   name: 'menu.user.competition',
    //   meta: {
    //     parentName: 'menu.user.deposit',
    //     parentIcon: 'fas fa-money-bill-alt',
    //   },
    //   component: () => import('../views/index/user/competition/CompDeposit.vue'),
    // },
      {
          path: 'deposit/competition',
          name: 'menu.user.competition',
          meta: {
              parentName: 'menu.user.deposit',
              parentIcon: 'fas fa-money-bill-alt',
          },
          component: () => import('../views/index/user/competition/Competition.vue'),
      },
    // {
    //   path: 'deposit/competition/new',
    //   name: 'menu.user.competition.new',
    //   meta: {
    //     parentName: 'menu.user.deposit',
    //     parentIcon: 'fas fa-money-bill-alt',
    //   },
    //   component: () => import('../views/index/user/competition/CompDepositNew.vue'),
    // },
    // {
    //   path: 'deposit/competition/:id',
    //   name: 'menu.user.competition.edit',
    //   meta: {
    //     parentName: 'menu.user.deposit',
    //     parentIcon: 'fas fa-money-bill-alt',
    //   },
    //   component: () => import('../views/index/user/competition/CompDepositEdit.vue'),
    // },

    {
      path: 'withdrawIndex',
      name: 'menu.user.withdraw',
      meta: {
        isParent: true,
        icon: 'far fa-money-bill-alt',
      },
      component: () => import('../views/index/user/withdraw/WithdrawIndex.vue'),
    },
    {
      path: 'withdrawIndex/withdraw/new',
      name: 'menu.user.withdrawIndex.withdraw.new',
      meta: {
        parentName: 'menu.user.withdraw',
        parentIcon: 'far fa-money-bill-alt',
      },
      component: () => import('../views/index/user/withdraw/WithdrawNew.vue'),
    },
    {
      path: 'withdrawIndex/withdraw/:id',
      name: 'menu.user.withdrawIndex.withdraw.edit',
      meta: {
        parentName: 'menu.user.withdraw',
        parentIcon: 'far fa-money-bill-alt',
      },
      component: () => import('../views/index/user/withdraw/WithdrawEdit.vue'),
    },
    {
      path: 'withdrawIndex/bank_card/new',
      name: 'menu.user.withdrawIndex.bank_card.new',
      meta: {
        parentName: 'menu.user.withdraw',
        parentIcon: 'far fa-money-bill-alt',
      },
      component: () => import('../views/index/user/payment/BankCardPost.vue'),
    },
    {
      path: 'withdrawIndex/bank_card/:id',
      name: 'menu.user.withdrawIndex.bank_card.edit',
      meta: {
        parentName: 'menu.user.withdraw',
        parentIcon: 'far fa-money-bill-alt',
      },
      component: () => import('../views/index/user/payment/BankCardPost.vue'),
    },
    // {
    //     path: 'depositHistory',
    //     name: 'menu.user.depositHistory',
    //     meta: {
    //         isParent: true,
    //         icon: 'fas fa-money-bill-alt',
    //     },
    //     component: () => import('../views/index/user/depositHistory/DepositHistory.vue'),
    // },
    // {
    //     path: 'withdrawHistory',
    //     name: 'menu.user.withdrawHistory',
    //     meta: {
    //         isParent: true,
    //         icon: 'fas fa-money-bill-alt',
    //     },
    //     component: () => import('../views/index/user/withdrawHistory/WithdrawHistory.vue'),
    // },
  ],
};
